import { postData } from '../../../services/api'
import { EXECUTIVE_DASHBOARD_CONFIG } from '../config'

const emptyFilter = { BranchNo: [], Season: [], TypeNo: [], CatalogNo: [], BudgetYear: [], Month: [], Day: [], Quarter: [], Unit: [] }

export const getExecutiveSummary = async (filter) => {
    const res = await postData(EXECUTIVE_DASHBOARD_CONFIG.requests.getExecutiveSummary.url, { ...emptyFilter, ...filter })
    if (res && res.status === true) {
        return res.result
    }
    return null
}

export const getExecutiveReadyToSell = async (filter) => {
    const res = await postData(EXECUTIVE_DASHBOARD_CONFIG.requests.getExecutiveReadyToSell.url, { ...emptyFilter, ...filter })
    if (res && res.status === true) {
        return res.result
    }
    return null
}

export const getExecutiveSales = async (filter) => {
    const res = await postData(EXECUTIVE_DASHBOARD_CONFIG.requests.getExecutiveSales.url, { ...emptyFilter, ...filter })
    if (res && res.status === true) {
        return res.result
    }
    return null
}
